import { render, staticRenderFns } from "./DiscrepancyImages.vue?vue&type=template&id=b23412f2&scoped=true&"
import script from "./DiscrepancyImages.vue?vue&type=script&lang=js&"
export * from "./DiscrepancyImages.vue?vue&type=script&lang=js&"
import style0 from "./DiscrepancyImages.vue?vue&type=style&index=0&id=b23412f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23412f2",
  null
  
)

export default component.exports